import { Button, Card, Col, Rate, Row, Tag } from 'antd';
import { styled } from 'styled-components';
import { FoodTitle } from './FoodTitle';
import { useEffect, useState } from 'react';
import { DeleteOutlined, HeartOutlined } from '@ant-design/icons';
import { VoteResult } from './VoteResult';
import { useNotifixationStore } from '../stores/notification';
import { useDeleteFoodFromMenu, useMenuQuery, useVoteMutation } from '../api';
import { Menu } from '../api/types';

export const FoodCard = ({
  menu,
  disabled,
}: {
  menu: Menu;
  disabled: boolean;
}) => {
  const [value, setValue] = useState(0);
  const { data: foods, refetch, isLoading } = useMenuQuery();
  const [votes, setVotes] = useState(menu.votes.items);

  const deleteMutation = useDeleteFoodFromMenu({
    onSuccess: () => {
      refetch();
    },
    onError: (error) => {
      addNotification({
        id: Math.random().toString(),
        message: 'Error!',
        code: error.response?.status,
        description: error.message,
        type: 'error',
      });
    },
  });

  const { addNotification } = useNotifixationStore();
  const mutation = useVoteMutation({
    onSuccess: () => {
      addNotification({
        id: Math.random().toString(),
        message: 'Thank you for voting!',
        code: 200,
        description: 'You can change your vote anytime.',
        type: 'success',
      });
      refetch();
    },
    onError: (error) => {
      addNotification({
        id: Math.random().toString(),
        message: 'Error!',
        code: error.response?.status,
        description: error.message,
        type: 'error',
      });
    },
  });

  const vote = async () => {
    mutation.mutate({ externalId: menu.externalId, vote: value });
  };

  useEffect(() => {
    const votedFood: Menu | undefined = foods?.find(
      (f) => f.externalId === menu.externalId
    );
    if (!votedFood) return;
    setVotes(votedFood.votes.items);
  }, [foods]);

  const renderActions = () => {
    return [
      <>{`${menu.from} - ${menu.to}`}</>,
      <Button
        loading={deleteMutation.isLoading}
        type='link'
        onClick={() => deleteMutation.mutate(menu.externalId)}
        danger
        size='small'
        icon={<DeleteOutlined />}
        disabled={!!menu.votes.items.length || disabled}
      />,
    ];
  };

  return (
    <MyCard
      hoverable
      actions={renderActions()}
      cover={
        <img
          alt={menu.food.name}
          src={menu.food.imageUrl}
          height={200}
          style={{ objectFit: 'cover' }}
        />
      }
    >
      <Row>
        <Col span={18}>
          <FoodTitle title={menu.food.name} />
        </Col>
        <Col span={6} style={{ paddingTop: 7 }}>
          <Tag color='#E44391'>{menu.food.type.title}</Tag>
        </Col>
      </Row>
      <Row>
        <Col span={16}>
          <DarkRate
            character={<HeartOutlined />}
            value={value}
            onChange={setValue}
            allowHalf
            disabled={disabled}
          />
        </Col>
        <Col span={6} offset={2}>
          <VoteButton
            loading={mutation.isLoading}
            disabled={disabled}
            onClick={vote}
            type='primary'
          >
            Vote
          </VoteButton>
        </Col>
      </Row>
      &nbsp;
      {isLoading || mutation.isLoading ? (
        <Loading>Loading...</Loading>
      ) : (
        <VoteResult votes={votes} />
      )}
    </MyCard>
  );
};

const VoteButton = styled(Button)`
  &:disabled {
    color: #aaaaaa;
  }
`;

const DarkRate = styled(Rate)`
  color: #ff3b2e;
  .ant-rate-star-zero {
    svg {
      color: grey;
    }
  }
`;
const MyCard = styled(Card)`
  width: 300px;
  margin-bottom: 50px;
  border-radius: 10px;
  background-color: #1d2336;
  border-color: #333333;
  cursor: default;
  .ant-card-actions {
    li {
      width: auto !important;
      padding-left: 25px;
      padding-right: 10px;
    }
  }
`;

const Loading = styled.div`
  color: #ffffff;
  text-align: center;
`;
